import { render, staticRenderFns } from "./AssetActivityLog.vue?vue&type=template&id=c536d4e4"
import script from "./AssetActivityLog.vue?vue&type=script&lang=js"
export * from "./AssetActivityLog.vue?vue&type=script&lang=js"
import style0 from "./AssetActivityLog.vue?vue&type=style&index=0&id=c536d4e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports